import Log from 'providers/log';
import CartItem from 'types/shopify/CartItem';
import Product from 'types/shopify/Product';
import Variant from 'types/shopify/Variant';

const LOCAL_STORAGE_KEY = 'gruhn-guitars-cart-contents';

const API_URL = process.env.DRUPAL_URL || 'http://drupal.guitars.test';
// Production
// const API_URL = 'http://www.guitars.com';

class Shopify {
    // TODO - This function is not named right. It should be called something closer to getAccessories
    // since this specific collection id is for Gruhn accessories
    public static getProducts = (): Promise<Product[]> => {
        return fetch(
            `${API_URL}/shopify/products?collection_id=231767878`,
            Shopify.getInit
        ).then((resp: Response) => {
            return resp.json();
        }).then((products: Product[]) => {
            return products;
        }).catch((error) => {
            Log.error(error);
            return [];
        });
    }

    public static getShopifyCollections = () =>  {
        return fetch(
            `${API_URL}/shopify/collections`
        ).then((resp: Response) => {
            return resp.json();
        }).catch((error) => {
            Log.error(error, 'Shopify.getUrl()');
            return 'gruhn-guitars.myshopify.com';
        });
    }

    public static calculateCartTotal = (products: Product[], cart: CartItem[]): number => {
        let total = 0;
        cart.forEach((item) => {
            total += (item.price * item.quantity);
        });
        return total;
    }

    public static getUrl = (): Promise<string> => {
        return fetch(
            `${API_URL}/shopify/hostname`,
            Shopify.getInit
        ).then((resp: Response) => {
            return resp.json();
        }).then((data: {hostname: string}) => {
            return data.hostname;
        }).catch((error) => {
            Log.error(error, 'Shopify.getUrl()');
            return 'gruhn-guitars.myshopify.com';
        });
    }

    public static generateCheckoutUrl = (hostname: string, cart: CartItem[]): string => {
        const path: string[] = [];
        cart.forEach((item) => {
            if (Number(item.quantity) < 1) return;
            path.push(`${item.variantId}:${item.quantity}`);
        });
        return `http://${hostname}/cart/${path.join(',')}`;
    }

    public static loadCartFromLocalStorage = (): CartItem[] => {
        let storedCart: CartItem[];
        try {
            storedCart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        } catch (e) {
            Log.error(e, 'shopify_cart.intialState()');
        }
        return  storedCart ? storedCart : [];
    }

    public static updateCartInLocalStorage = (cart: CartItem[]) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cart));
    }

    public static clearLocalStorage = () => {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    }

    public static pruneInvalidProducts = (cart: CartItem[], products: Product[]): CartItem[] => {
        // Select variant IDs from products
        const variantIds = [].concat.apply([], products.map(p => p.variants)).map((v: Variant) => v.id);

        return cart.filter((item) => {
            return variantIds.indexOf(item.variantId) !== -1;
        });
    }

    public static getProductCollection = (collectionId: number) => {
        return fetch(
            `${API_URL}/shopify/products?collectionId=${collectionId}&limit=5`,
            Shopify.getInit
        ).then((resp: Response) => {
            return resp.json();
        }).then((products: Product[]) => {
            return products;
        }).catch((error) => {
            Log.error(error);
            return [];
        });
    }

    private static getInit: RequestInit = {
        method: 'get'
    };

    // Intsanced implemenation commented out:
    // private products: Product[] = [];
    // private hostname: string = '';

    // TODO: Collections are unused, may not need the below comments
    // private collections: any[] = [];
    // private productsInCollections: any = {};

    // public getProduct = (id: number, callback: (product: Product) => void): Product => {
    //     let retVal: Product;
    //     if (this.products) {
    //         retVal = this.products.find(p => p.id === id);
    //         if (retVal) {
    //             callback(retVal);
    //             return retVal;
    //         }
    //     }
    //     fetch(
    //         `http://www.guitars.com/shopify/products?product_id=${id}`,
    //         this.getInit
    //     ).then((resp: Response) => {
    //         return resp.json();
    //     }).then((product: Product) => {
    //         retVal = product;
    //     });
    //     if (retVal) {
    //         callback(retVal);
    //         return retVal;
    //     }
    //     Log.error(`Product with id ${id} could not be located`, 'Shopify.getProduct');
    //     return null;
    // }

    // public getVariant = (id: number, callback: (variant: Variant) => void): Variant => {
    //     let retVal: Variant;
    //     fetch(
    //         `http://www.guitars.com/shopify/products?variant_id=${id}`,
    //         this.getInit
    //     ).then((resp: Response) => {
    //         return resp.json();
    //     }).then((variant: Variant) => {
    //         retVal = variant;
    //     });

    //     if (retVal) {
    //         callback(retVal);
    //         return retVal;
    //     }
    //     Log.error(`Variant with id ${id} could not be located`, 'Shopify.getVariant');
    //     return null;
    // }

    // TODO: do we need this?
    // this.getProductsInCollection = function(collectionId, callback) {
    // 	if (typeof this.productsInCollections.collectionId !== 'undefined') {
    // 		return callback(this.productsInCollections[collectionId]);
    // 	}

    // 	return reqwest({
    // 		url: '/shopify/products',
    // 		method: 'get',
    // 		dataType: 'json',
    // 		data: {
    // 			collection_id: collectionId,
    // 			limit: 100
    // 		},
    // 		success: function(products) {
    // 			this.productsInCollections[collectionId] = products;
    // 			return callback(products);
    // 		}.bind(this)
    // 	});
    // };
}

export default Shopify;



// WEBPACK FOOTER //
// ./src/providers/shopify.ts